<template>
	<screen class="pre-card-view" type="blue">
		<template slot="header">
			<ui-header type="dark" @click="onBack">
				<h2 slot="title">Choose Your Funding Source</h2>
			</ui-header>
		</template>
		<p>
			We will use this card as your method of payment for your donations.
		</p>
		<img src="@/assets/creditCard.svg" />
		<ui-button color="white" @click="next">Enter a Card</ui-button>
	</screen>
</template>

<script>
import UiButton from '../../ui/Button'
import UiHeader from '../../ui/Header'
//import PreSection from '../../ui/PreSection'
import Screen from '../../ui/Screen'

export default {
	name: 'pre-card-view',
	components: { UiButton, UiHeader, Screen },
	methods: {
		next() {
			this.navigate(
				{
					name: 'card',
					params: {
						onboarding: true,
						backRoute: 'pre-card',
						nextRoute: 'pre-accounts'
					}
				},
				'forward'
			)
		},
		onBack() {
			this.navigate({ name: 'mindonation' }, 'back')
		}
	}
}
</script>

<style lang="scss">
.pre-card-view {
	p {
		color: $white;
	}
}
</style>
